import React, { FC, memo } from 'react'
import { FormattedRatingAnswer } from '../../../../../models/property-details-page/reviews-model'
import {
    ReviewContainer,
    ReviewTitleWrapper,
    ReviewAnswerTitle,
    ReviewAnswerDate,
    ReviewAnswerTextContainer,
} from './styles'
import { Typography } from 'react-components'

interface ReviewAnswerProps {
    answer: FormattedRatingAnswer
    replyTitle: string
}

const ReviewAnswer: FC<ReviewAnswerProps> = ({ answer, replyTitle }) => {
    return (
        <ReviewContainer>
            <ReviewTitleWrapper>
                <ReviewAnswerTitle>
                    <Typography variant="subtitle2" fontWeight="semiBold">
                        {replyTitle}
                    </Typography>
                </ReviewAnswerTitle>
                {!!answer.date && (
                    <ReviewAnswerDate>
                        <Typography variant="caption">{answer.date}</Typography>
                    </ReviewAnswerDate>
                )}
            </ReviewTitleWrapper>
            <ReviewAnswerTextContainer>
                <Typography variant="caption">{answer.text}</Typography>
            </ReviewAnswerTextContainer>
        </ReviewContainer>
    )
}

export default memo(ReviewAnswer)
